import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsProductsAccessRoute: InvariantJiraRoute = {
	name: 'global-settings-products-access',
	path: '/secure/admin/ApplicationAccess.jspa',
};
